import { render, staticRenderFns } from "./GroupsEditForm.vue?vue&type=template&id=71d464b6&scoped=true"
import script from "./GroupsEditForm.vue?vue&type=script&lang=js"
export * from "./GroupsEditForm.vue?vue&type=script&lang=js"
import style0 from "./GroupsEditForm.vue?vue&type=style&index=0&id=71d464b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d464b6",
  null
  
)

export default component.exports